export const theme = {
  color: {
    bg: ['#0a0a0b', '#111113', '#17171a', '#1d1d22', '#24242a'] as const,
    hover: '#2a2a31',
    border: {
      faint: 'rgba(255,255,255,0.06)',
      soft: 'rgba(255,255,255,0.09)',
      med: 'rgba(255,255,255,0.14)',
      strong: 'rgba(255,255,255,0.22)',
    },
    text: ['#f5f4f0', '#d8d6cf', '#9a9890', '#6b6a63', '#4a4944'] as const,
    accent: {
      amber: '#ff9d2e',
      amberBright: '#ffb547',
      amberDim: '#c77a1f',
      amberGlow: 'rgba(255,157,46,0.14)',
      amberLine: 'rgba(255,157,46,0.35)',
    },
    semantic: {
      up: '#3ddc84',
      upDim: '#27a865',
      upBg: 'rgba(61,220,132,0.08)',
      down: '#ff5d5d',
      downDim: '#cc4545',
      downBg: 'rgba(255,93,93,0.08)',
      flat: '#9a9890',
    },
    category: {
      amber: '#ff9d2e',
      cyan: '#5ec9f5',
      violet: '#a88dfb',
      rose: '#f599b8',
      lime: '#c4e85c',
    },
  },
  font: {
    sans: '"Inter Tight", "Helvetica Neue", system-ui, sans-serif',
    serif: '"Source Serif 4", "Iowan Old Style", Georgia, serif',
    mono: '"JetBrains Mono", "IBM Plex Mono", ui-monospace, Menlo, monospace',
  },
  step: [11, 12, 13, 14, 16, 20, 24, 32, 44, 60, 84, 120] as const,
  layout: {
    maxw: 1440,
    gutter: 24,
    rail: 44,
    nav: 56,
  },
  ease: 'cubic-bezier(0.2, 0.7, 0.2, 1)',
} as const;

export type Theme = typeof theme;
